import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TrainingType } from '../../../message-models/training-record-type.class';
import { ITrainingType } from '../../../message-models/training-record-type.interface';
import { TrainingRecordsService } from '../../../training-records/services/training-records.service';
import { OurUserService } from '../../../users/services/user.service';
import { IAllowedOperations, IUserInfo } from '../../../users/models/userInfo.interface';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { ExportExcelService } from '../../../common/services/export-excel.service';
import { DatePipe } from '@angular/common';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { TrainingCourseEditorComponent } from '../../training-course-editor/training-course-editor.component';
import { MenuItem } from 'primeng/api';
import { EcaDynamicModalService } from "../../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../../shared/models/eca-dialog-ref.interface';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentService } from '../../../documents/services/document.service';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { Router } from '@angular/router';
import { TrainingTypeDocumentService } from '../../../training-records/services/training-type-document.service';
import { ListDataService } from '../../../services/list-data.service';
import { ITrainingTypeCategoryInfo } from '../../../message-models/trainning-record-category.interface';
import { EcaConfirmInfoModalOptions } from '../../../shared/models/confirm-info-modal-options.class';
import { ITrainingRecordSummary } from '../../../message-models/training-record-summary.interface';

@Component({
  selector: 'app-company-training-courses',
  templateUrl: './company-training-courses.component.html',
  styleUrls: ['./company-training-courses.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CompanyTrainingCoursesComponent implements OnInit {
  private loggedInUser: IUserInfo;
  private modalRef: IEcaDialogRef;
  trainingTypes: TrainingType[] = [];
  public companyId: string = consts.emptyGuid;
  public operativeUpdateOperations: IAllowedOperations = {} as IAllowedOperations;
  allTrainingTypeCategory: ITrainingTypeCategoryInfo[] = [];
  selectTrainingTypeCategory: ITrainingTypeCategoryInfo;
  loggedInUserSubscription: Subscription;
  canAddItem: boolean = true;
  coursesLoading: boolean = false;
  isOnMobile = false;
  columns: any[];
  trainingTypesListToExport: any[] = [];
  rowMenuItems: MenuItem[];
  companyDocumentSummaries: IDocumentSummaryInfo[] = [];
  newTrainingTypeId: string;
  isActive = false;

  trainingRecords: ITrainingRecordSummary[] = [];

  constructor(private router: Router,
    private trainingRecordsService: TrainingRecordsService,
    private exportExcelService: ExportExcelService,
    private userService: OurUserService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private confirmProcessService: EcaConfirmProcessService,
    private helpService: HelpModalService,
    private datePipe: DatePipe,
    private ecaDynamicModalService: EcaDynamicModalService,
    private documentModalService: DocumentModalService,
    private errorHandlingService: ErrorHandlingService,
    private alertsService: AlertsService,
    private listDataService: ListDataService,
    private trainingTypeDocumentService: TrainingTypeDocumentService, ) {
  }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.listDataService.getAllTrainTypeCategory().subscribe({
      next: response => {
        this.allTrainingTypeCategory = response;
      }
    });


    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser.companyId;
      if (this.loggedInUser?.operativeOperations?.canUpdate) {
        this.operativeUpdateOperations = { canInsert: true, canUpdate: true, canRetrieve: true, canDelete: true } as IAllowedOperations;
      } else {
        this.operativeUpdateOperations = {} as IAllowedOperations;
      }
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.loggedInUser = user;
        this.companyId = this.loggedInUser?.companyId;
        if (this.loggedInUser?.operativeOperations?.canUpdate) {
          this.operativeUpdateOperations = { canInsert: true, canUpdate: true, canRetrieve: true, canDelete: true } as IAllowedOperations;
        } else {
          this.operativeUpdateOperations = {} as IAllowedOperations;
        }
        if (this.companyId !== consts.emptyGuid && this.companyId !== undefined) {
          this.getAllTrainingTypes();
          this.getAllTrainingRecordsForComapny();
        }
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });

    this.columns = [{ field: 'name', header: 'Course Name', type: 'text' },
    { field: 'description', header: 'Course Description', type: 'html' },
      { field: 'trainingTypeCategoryName', header: 'Course Category', type: 'text' },
    { field: 'heldOn', header: 'Held On', type: 'date' },
    { field: 'validTo', header: 'Valid To', type: 'date' },
    ];

    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        visible: true,
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.confirmDeleteItem($event)
      }
    ]

    this.populateBreadcrumbs();

    


  }

  private getAllTrainingTypes() {
    this.coursesLoading = true;
    this.trainingRecordsService.getTrainingTypesForCompany(this.companyId, false).subscribe(trainingTypesResult => {
      this.trainingTypes = [];
      this.coursesLoading = false;
      trainingTypesResult.forEach(t => {
        t.trainingTypeCategoryName = this.allTrainingTypeCategory.find(x => x.id === t.trainingTypeCategoryId)?.name;

        this.trainingTypes.push(new TrainingType(t));
      });
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }


  addNewItemClick() {
    let trainingType = new TrainingType();
    trainingType.companyId = this.loggedInUser?.companyId;
    this.openEditor(trainingType, 'Add New Training Course');
  }

  editItemClick(item: ITrainingType) {
    let trainingType = new TrainingType(item);
    //this.openEditor(trainingType, 'Edit Existing Training Course - ' + item.name);
    this.router.navigate(["/training-course/" + item.id])
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();

    operativeBreadCrumbs.push({
      label: 'Training Courses',
      iconName: 'users-class'
    } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  private openEditor(trainingType: TrainingType, heading: string) {
    let config = {
      styleClass: 'modal-dialog-scrollable modal-lg',
      baseZIndex: 2000,
      showHeader: false,
      data: {
        heading: heading,
        trainingType: trainingType
      }
    } as DynamicDialogConfig;

    this.modalRef = this.ecaDynamicModalService.openDialog(TrainingCourseEditorComponent, config);
    this.modalRef.content.choiceMade.subscribe(result => {
      if (result) {
        this.coursesLoading = true;
        this.trainingRecordsService.createOrUpdateCompanyTrainingType(result).subscribe(updatedJobTitle => {
          if (updatedJobTitle) {
            this.getAllTrainingTypes();
            this.coursesLoading = false;
          }
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
      }
    });
    this.modalRef.content.saveNewTrainingTypeDocumentRequested.subscribe(result => {
      if (result) {
        this.coursesLoading = true;
        this.trainingRecordsService.createOrUpdateCompanyTrainingType(result).subscribe(updatedTrainingType => {
          if (updatedTrainingType) {
            this.getAllTrainingTypes();
            this.newTrainingTypeId = updatedTrainingType.id;
            this.coursesLoading = false;
          }
        }, () => {
          this.errorHandlingService.showErrorWarning().subscribe(() => {
          });
        });
        this.documentModalService.openDocumentUploaderModal({ documentCreationDate: result.HeldOn } as IEntityDocumentSummary
          , DocumentEntityType.trainingCourse, 'Add new Document for Training Course')
          .subscribe(documentModalRef => {
            documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
              documentModalRef.dynamicDialogRef.close()
              documentUploadRequest.append('CompanyId', this.companyId);
              documentUploadRequest.append('TrainingTypeId', this.newTrainingTypeId);
              this.trainingTypeDocumentService.createOrUpdateTrainingTypeDocument(documentUploadRequest).subscribe(trainingTypeDocumentSummary => {
                //this.getCompanyDocumentSummaries(this.companyId);
                this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
              }, () => {
                this.errorHandlingService.showErrorWarning().subscribe(() => {
                });
              });        
            });
            documentModalRef.content.cancelClicked?.subscribe(() => {
            });
        });
      }
    });
  }
  
  confirmDeleteItem(trainingType: ITrainingType) {

    this.isActive = this.isActiveTrainingType(trainingType);
    if (!this.isActive) {
      this.confirmProcessService.openConfirmProcessModal('<p>Are you SURE you wish to DELETE this training course?</p>', 'Confirm Deletion', new EcaConfirmDeleteModalOptions())
        .subscribe(result => {
          if (result) {
            this.coursesLoading = true;
            this.trainingRecordsService.deleteTrainingType(trainingType).subscribe(result => {
              this.getAllTrainingTypes();
              this.coursesLoading = false;
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
              });
            });
          }
        });
    } else {
      this.confirmProcessService.openConfirmProcessModal('<p>Training Course can only be deleted if they are not in use</p>', 'Remove Training Course'
        , new EcaConfirmInfoModalOptions()).subscribe({});
    }

    //this.confirmProcessService.openConfirmProcessModal('<p>Are you SURE you wish to DELETE this training course?</p><p>This will not remove it from existing operative training records.</p>', 'Confirm Deletion', new EcaConfirmDeleteModalOptions())
    //  .subscribe(result => {
    //    if (result) {
    //      this.coursesLoading = true;
    //      this.trainingRecordsService.deleteTrainingType(trainingType).subscribe(result => {
    //        this.getAllTrainingTypes();
    //        this.coursesLoading = false;
    //      }, () => {
    //        this.errorHandlingService.showErrorWarning().subscribe(() => {
    //        });
    //      });
    //    }
    //  });
  }

  openCompanyTrainingCoursesHelp() {
    this.helpService.openHelpModal(HelpConsts.CompanyTrainingCoursesHelp);
  }

  exportToExcel() {
    this.trainingTypesListToExport = [];
    this.trainingTypes?.forEach(element => {
      let html = element?.description;
      let div = document.createElement('div');
      div.innerHTML = html;
      let text = div.textContent || div.innerText || '';
      const tempObject = {
        name: element?.name,
        description: text,
        heldOn: this.datePipe.transform(element.heldOn?.dateTime, 'dd/MM/yyyy'),
        validTo: this.datePipe.transform(element.validTo?.dateTime, 'dd/MM/yyyy'),
      };
      this.trainingTypesListToExport.push(tempObject);
    });
    this.exportExcelService.exportToExcel(this.trainingTypesListToExport, this.columns, 'Training Courses');
  }

  private getAllTrainingRecordsForComapny(){
    this.trainingRecordsService.getTrainingRecordSummariesForCompany(this.companyId).subscribe(trainingRecords => {
      this.trainingRecords = trainingRecords;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
}


  isActiveTrainingType(trainingType: ITrainingType) {
    var list = this.trainingRecords.find(o => o.trainingTypeId == trainingType.id);
    if (list != null) {
      return true;
    }
    else return false;
  }
}
